
import IconTargetAccent from "~/components/icons/IconTargetAccent.vue";

export default {
  components: {
    IconTargetAccent,
  },

  props: {
    h1: { type: String, required: true },
  },

  computed: {
    city() {
      return this.$store.getters["sliders/getDubaiAllCount"];
    },
  },

  methods: {
    openCityModal() {
      this.$store.commit("global/setModalChangeCityStatus");
    },

    openAdvancedSearch() {
      this.$root.$emit("openAdvancedSearch");
    },
  },
};
